// extracted by mini-css-extract-plugin
export default {"wrapper":"Agreetment_wrapper__Nc3dq","main":"Agreetment_main__daYyG"};